module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"10","cy":"10","fill":"#bf0049","r":"5.6"}}),_c('path',{attrs:{"d":"M10.8 9.9L12.7 8c.2-.2.2-.6 0-.8-.2-.2-.6-.2-.8 0L10 9 8.1 7.1c-.2-.2-.6-.2-.8 0s-.3.7-.1.9l1.9 1.9-1.9 1.9c-.2.2-.2.6 0 .8.1.1.3.2.4.2s.3-.1.4-.2l1.9-1.9 1.9 1.9c.1.1.3.2.4.2s.3-.1.4-.2c.2-.2.2-.6 0-.8l-1.8-1.9z","fill":"#fff"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/delete.svg
// module id = 178
// module chunks = 2